module.exports = __webpack_public_path__ + "static/event-3-d06028dcd351f649e79a3239a33368bb.jpg";